<template>
  <div>
    <el-dialog
      class="dialog-automv"
      :visible.sync="openAutoMVView"
      width="80%"
      :close-on-click-modal="false"
      @close="onClose"
      append-to-body
    >
      <el-card>
        <div class="flex-col">
          <el-image
            style="
              width: 150px;
              height: 150px;
              border-radius: 100px;
              margin-left: 35px;
            "
            :src="AutoMVFormModel.OwnerImage"
          ></el-image>
          <h3 style="margin-left: 20px">
            {{ AutoMVFormModel.OwnerFullName }}
          </h3>
        </div>

        <div class="overlap-group6-AutoMV">
          <div class="rectangle-3-AutoMV"></div>
          <h1 class="title-AutoMV">{{ title }}</h1>
          <h4 class="ActualDate-AutoMV">
            {{ DateAutoMV }}
          </h4>
          <div class="rectangle-4-AutoMV"></div>
        </div>

        <!-- <div style="display: flex; float: right">
          <h3 style="margin-left: 20px">
            {{
              "Porcetanje de la semana: " + AutoMVFormModel.WeekPercentage + "%"
            }}
          </h3>
          <h3 style="margin-left: 20px">
            {{ "Porcetanje total : " + AutoMVFormModel.TotalPercentage + "%" }}
          </h3>
        </div> -->

        <el-form
          label-position="top"
          :model="AutoMVFormModel"
          ref="ruleForm"
          style="margin-top: 80px"
        >
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane
              label="Estrategico"
              name="first"
              value="1"
            ></el-tab-pane>
            <el-tab-pane
              label="Operacionales"
              name="second"
              value="2"
            ></el-tab-pane>
          </el-tabs>
          <div
            style="
              display: flex;
              flex-direction: column;
              align-items: end;
              margin-bottom: 5px;
              width: 100%;
            "
          >
            <div style="display: flex; float: right">
              <h3>
                {{
                  indexTabs === "1"
                    ? "Porcetanje de la semana: " +
                      totalPorcentaje(datePercetangeWeekOperacional) +
                      "% : "
                    : "Porcetanje de la semana: " +
                      totalPorcentaje(datePercetangeWeekEstrategico) +
                      "% : "
                }}
              </h3>

              <h3
                style="
                  margin-left: 20px;
                  color: green;
                  background-color: rgba(87, 255, 29, 0.1);
                "
              >
                {{
                  indexTabs === "1"
                    ? "Cerrada a tiempo: " + dataTaksClosedOnTimeOperacional
                    : "Cerrada a tiempo: " + dataTaksClosedOnTimeEstrategico
                }}
              </h3>
              <!-- <h3
              style="
                margin-left: 20px;
                color: green;
                background-color: rgba(87, 255, 29, 0.1);
              "
            >
              {{
                indexTabs === "1"
                  ? "Abierta a tiempo: " + dataTaksOpenOnTimeOperacional
                  : "Abierta a tiempo: " + dataTaksOpenOnTimeEstrategico
              }}
            </h3> -->

              <h3
                style="
                  margin-left: 20px;
                  color: red;
                  background-color: rgba(255, 29, 29, 0.1);
                "
              >
                {{
                  indexTabs === "1"
                    ? "Cerrada Retrasada: " +
                      dataTaskCloseOnLateOnWeekOperacional
                    : "Cerrada Retrasada: " +
                      dataTaskCloseOnLateOnWeekEstrategico
                }}
              </h3>
              <h3
                style="
                  margin-left: 20px;
                  color: red;
                  background-color: rgba(255, 29, 29, 0.1);
                "
              >
                {{
                  indexTabs === "1"
                    ? "Abierta Retrasada: " +
                      dataTaskOpenOnLateOnWeekOperacional
                    : "Abierta Retrasada: " +
                      dataTaskOpenOnLateOnWeekEstrategico
                }}
              </h3>
            </div>

            <div
              style="
                display: flex;
                float: right;
                margin-top: 1%;
                margin-bottom: 5%;
              "
            >
              <h3>
                {{
                  indexTabs === "1"
                    ? "Porcetanje total : " +
                      totalPorcentaje(datePercetangeTotalOperacionall) +
                      "% :"
                    : "Porcetanje total : " +
                      totalPorcentaje(datePercetangeTotalEstrategico) +
                      "% :"
                }}
              </h3>
              <h3
                style="
                  margin-left: 20px;
                  color: green;
                  background-color: rgba(87, 255, 29, 0.1);
                "
              >
                {{
                  indexTabs === "1"
                    ? "Cerrada a tiempo: " +
                      dataTotalTaksClosedOnTimeOperacional
                    : "Cerrada a tiempo: " +
                      dataTotalTaksClosedOnTimeEstrategico
                }}
              </h3>
              <!-- <h3
              style="
                margin-left: 20px;
                color: green;
                background-color: rgba(87, 255, 29, 0.1);
              "
            >
              {{
                indexTabs === "1"
                  ? "Abierta a tiempo: " + dataTotalTaksOpenOnTimeOperacional
                  : "Abierta a tiempo: " + dataTotalTaksOpenOnTimeEstrategico
              }}
            </h3> -->

              <h3
                style="
                  margin-left: 20px;
                  color: red;
                  background-color: rgba(255, 29, 29, 0.1);
                "
              >
                {{
                  indexTabs === "1"
                    ? "Cerrada Retrasada: " +
                      dataTotalTaksClosedOnLateOperacional
                    : "Cerrada Retrasada: " +
                      dataTotalTaksClosedOnLateEstrategicoo
                }}
              </h3>
              <h3
                style="
                  margin-left: 20px;
                  color: red;
                  background-color: rgba(255, 29, 29, 0.1);
                "
              >
                {{
                  indexTabs === "1"
                    ? "Abierta Retrasada: " + dataTotalTaksOpenOnLateOperacional
                    : "Abierta Retrasada: " + dataTotalTaksOpenOnLateEstrategico
                }}
              </h3>
            </div>
          </div>

          <div class="labels-AutoMV">
            <div class="overlap-group-1-AutoMV">
              <div class="texts-labels-AutoMV inter-bold-white-20px">
                {{ objetivos }}
              </div>
            </div>
          </div>
          <div style="display: flex; float: right">
            <DepartmentSelector
              v-if="this.currentUser.EmployeeId == 37"
              @selection-change="selectionChange"
              :onlyDepartment="true"
            />

            <!-- select employeeId -->
            <el-select
              v-if="this.currentUser.EmployeeId == 37"
              v-loading="loading"
              v-model="responsableId"
              filterable
              clearable
              size="mini"
              placeholder="Responsable"
              @change="employeeChage"
            >
              <el-option
                v-for="item in employees"
                :key="item.EmployeeID"
                :label="item.Name"
                :value="item.EmployeeID"
              >
              </el-option>
            </el-select>

            <!-- select employeeId -->
            <el-select
              v-if="this.currentUser.EmployeeId != 37"
              v-loading="loading"
              v-model="responsableId"
              filterable
              clearable
              size="mini"
              placeholder="Responsable"
              @change="employeeChage"
            >
              <el-option
                v-for="item in employeesByDirection"
                :key="item.EmployeeID"
                :label="item.Name"
                :value="item.EmployeeID"
              >
              </el-option>
            </el-select>
          </div>

          <el-form-item label="TAREAS" style="margin-top: 50px">
            <rabbey-table-3
              :data="tableDataOperacional"
              :columns="columnTask"
              :loading="loadingForm"
              :maxheight="400"
              v-if="indexTabs === '1'"
            />

            <rabbey-table-3
              :data="tableDataEstrategico"
              :columns="columnTask"
              :loading="loadingForm"
              :maxheight="400"
              v-if="indexTabs === '0'"
            />
          </el-form-item>

          <el-row align="middle" class="rowTagsquil">
            <div class="labels-AutoMV">
              <div class="overlap-group-1-AutoMV">
                <div class="texts-labels-AutoMV inter-bold-white-20px">
                  {{ celebraciones }}
                </div>
              </div>
              <p class="label-description-AutoMV inter-bold-black-20px">
                {{ cosasQueCelebroY }}
              </p>
            </div>
            <el-form-item>
              <el-input
                type="textarea"
                placeholder="Please input"
                v-model="AutoMVFormModel.Celebrations"
                minlength="200"
                maxlength="2000"
                :autosize="{ minRows: 10, maxRows: 10 }"
                show-word-limit
                disabled
              >
              </el-input>
            </el-form-item>
          </el-row>

          <el-row align="middle" class="rowTagsquil">
            <div class="labels-AutoMV">
              <div class="overlap-group-1-AutoMV">
                <div class="texts-labels-AutoMV inter-bold-white-20px">
                  {{ revisiones }}
                </div>
              </div>
              <p class="label-description-AutoMV inter-bold-black-20px">
                {{ cosasQueSeQuePud }}
              </p>
            </div>
            <el-form-item>
              <el-input
                type="textarea"
                placeholder="Please input"
                v-model="AutoMVFormModel.Revisions"
                minlength="200"
                maxlength="2000"
                :autosize="{ minRows: 10, maxRows: 10 }"
                show-word-limit
                disabled
              >
              </el-input>
            </el-form-item>
          </el-row>

          <el-row align="middle" class="rowTagsquil">
            <div class="labels-AutoMV">
              <div class="overlap-group-1-AutoMV">
                <div class="texts-labels-AutoMV inter-bold-white-20px">
                  {{ alertas }}
                </div>
              </div>
              <p class="label-description-AutoMV inter-bold-black-20px">
                {{ informacionesQueLl }}
              </p>
            </div>
            <el-form-item>
              <el-input
                type="textarea"
                placeholder="Please input"
                v-model="AutoMVFormModel.Alerts"
                minlength="200"
                maxlength="2000"
                :autosize="{ minRows: 10, maxRows: 10 }"
                show-word-limit
                disabled
              >
              </el-input>
            </el-form-item>
          </el-row>

          <el-row align="middle" class="rowTagsquil">
            <div class="labels-AutoMV">
              <div class="overlap-group-1-AutoMV">
                <div class="texts-labels-AutoMV inter-bold-white-20px">
                  {{ aprendizajes }}
                </div>
              </div>
              <p class="label-description-AutoMV inter-bold-black-20px">
                {{ momentosAja0Apl }}
              </p>
            </div>
            <el-form-item>
              <el-input
                type="textarea"
                placeholder="Please input"
                v-model="AutoMVFormModel.Learnings"
                minlength="200"
                maxlength="2000"
                :autosize="{ minRows: 10, maxRows: 10 }"
                show-word-limit
                disabled
              >
              </el-input>
            </el-form-item>
          </el-row>

          <el-row align="middle" class="rowTagsquil">
            <div class="labels-AutoMV">
              <div class="overlap-group-1-AutoMV">
                <div class="texts-labels-AutoMV inter-bold-white-20px">
                  {{ innovaciones }}
                </div>
              </div>
              <p class="label-description-AutoMV inter-bold-black-20px">
                {{ cosasQueHaraMejor0Diferente }}
              </p>
            </div>
            <el-form-item>
              <el-input
                type="textarea"
                placeholder="Please input"
                v-model="AutoMVFormModel.Innovation"
                minlength="200"
                maxlength="2000"
                :autosize="{ minRows: 10, maxRows: 10 }"
                show-word-limit
                disabled
              >
              </el-input>
            </el-form-item>

            <el-form-item v-if="isSupervisor || AutoMVFormModel.Ranting > 0">
              <div class="labels-AutoMV">
                <div class="overlap-group-1-AutoMV">
                  <div class="texts-labels-AutoMV inter-bold-white-20px">
                    CALIFICACIÓN
                  </div>
                </div>
              </div>

              <el-input-number
                v-if="AutoMVFormModel.Ranting > 0"
                v-model="AutoMVFormModel.Ranting"
                disabled
                :min="1"
                :max="100"
              >
              </el-input-number>

              <el-input
                v-if="AutoMVFormModel.Ranting > 0"
                style="margin-top: 10px; margin-bottom: 10px"
                type="textarea"
                placeholder="Comentario de calificación"
                v-model="AutoMVFormModel.RatingComment"
                disabled
                minlength="200"
                maxlength="2000"
              />

              <el-input-number
                v-if="AutoMVFormModel.Ranting == null"
                v-model="Ranting"
                :min="1"
                :max="100"
              >
              </el-input-number>

              <el-input
                v-if="AutoMVFormModel.Ranting == null"
                style="margin-top: 10px; margin-bottom: 10px"
                type="textarea"
                placeholder="Comentario de calificación"
                v-model="RantingComment"
                minlength="200"
                maxlength="2000"
              />

              <el-button
                v-if="AutoMVFormModel.Ranting == null"
                :loading="loading"
                type="primary"
                @click="onSubmit()"
                >Create</el-button
              >
            </el-form-item>
          </el-row>
        </el-form>
      </el-card>
    </el-dialog>
  </div>
</template>

<script>
import { formatDate } from "@/utils";
// import tasks from "@/columns/tasksGanttAutoMV";
import tasks from "@/columns/tasksGanttAutoMVview";
import DepartmentSelector from "@/components/Company/DepartmentSelector.vue";

export default {
  formatDate,
  components: {
    DepartmentSelector
  },
  name: "ViewAutoMvForm",
  props: {
    openAutoMVView: {
      type: Boolean,
      default: false
    },
    isSupervisor: {
      type: Boolean,
      default: false
    },
    AutoMVFormModel: {
      type: Object,
      default: () => {}
    },
    TasktableDataOperacional: {
      type: Array,
      default: () => []
    },
    totalTaksClosedOnTimeOperacional: {
      type: Number,
      default: 0
    },
    totalTaksClosedOnLateOperacional: {
      type: Number,
      default: 0
    },
    totalTaksOpenOnTimeOperacional: {
      type: Number,
      default: 0
    },
    totalTaksOpenOnLateOperacional: {
      type: Number,
      default: 0
    },
    taksOpenOnTimeOperacional: {
      type: Number,
      default: 0
    },
    taskOpenOnLateOnWeekOperacional: {
      type: Number,
      default: 0
    },
    taskCloseOnLateOnWeekOperacional: {
      type: Number,
      default: 0
    },

    percetangeWeekOperacional: {
      type: Number,
      default: 0
    },

    percetangeTotalOperacionall: {
      type: Number,
      default: 0
    },

    TasktableDataEstrategico: {
      type: Array,
      default: () => []
    },
    totalTaksClosedOnTimeEstrategico: {
      type: Number,
      default: 0
    },
    totalTaksClosedOnLateEstrategicoo: {
      type: Number,
      default: 0
    },
    totalTaksOpenOnTimeEstrategico: {
      type: Number,
      default: 0
    },
    totalTaksOpenOnLateEstrategico: {
      type: Number,
      default: 0
    },
    taskOpenOnLateOnWeekEstrategico: {
      type: Number,
      default: 0
    },
    taskCloseOnLateOnWeekEstrategico: {
      type: Number,
      default: 0
    },
    percetangeWeekEstrategico: {
      type: Number,
      default: 0
    },

    taksClosedOnTimeOperacional: {
      type: Number,
      default: 0
    },

    taksClosedOnTimeEstrategico: {
      type: Number,
      default: 0
    },

    taksOpenOnTimeEstrategico: {
      type: Number,
      default: 0
    },

    percetangeTotalEstrategico: {
      type: Number,
      default: 0
    },

    loadingFormItem: {
      type: Boolean,
      require: false,
      default: false
    },

    createdAt: {
      type: String,
      require: false
    }

    // TasktableData: {
    //   type: Array,
    //   default: () => []
    // },
    // totalTaksClosedOnTime: {
    //   type: Number,
    //   default: 0
    // },
    // totalTaksClosedOnLate: {
    //   type: Number,
    //   default: 0
    // },
    // totalTaksOpenOnTime: {
    //   type: Number,
    //   default: 0
    // },
    // totalTaksOpenOnLate: {
    //   type: Number,
    //   default: 0
    // },
    // taskOpenOnLateOnWeek: {
    //   type: Number,
    //   default: 0
    // },
    // taskCloseOnLateOnWeek: {
    //   type: Number,
    //   default: 0
    // }
  },
  data() {
    return {
      activeName: "first",
      indexTabs: "0",
      columnTask: tasks,
      objetivos: "OBJETIVOS",
      loading: false,
      title: "AutoMV",
      semanaDel01AlOGEne2623: "Semana del 01 al 06 ENE 2023",
      celebraciones: "CELEBRACIONES",
      cosasQueCelebroY: "Cosas que celebro y me hacen feliz de haber logrado.",
      revisiones: "REVISIONES",
      cosasQueSeQuePud: "Cosas que se que pude hacer mejor o no hice bien.",
      alertas: "ALERTAS",
      informacionesQueLl:
        "Informaciones que llaman mi atención y debo actuar sobre ellas.",
      aprendizajes: "APRENDIZAJES",
      momentosAja0Apl:
        "Momentos 'AJA' o aplicaciones de conceptos que me dieron productividad.",
      innovaciones: "INNOVACIONES",
      cosasQueHaraMejor0Diferente: "Cosas que haria mejor o diferente.",
      Ranting: "",
      RantingComment: "",

      responsableId: "",
      employees: [],
      employeesByDirection: [],
      departmentId: null,
      tableDataEstrategico: [],
      tableDataOperacional: [],
      datePercetangeWeekOperacional: 0,
      datePercetangeWeekEstrategico: 0,
      datePercetangeTotalOperacionall: 0,
      datePercetangeTotalEstrategico: 0,

      dataTotalTaksClosedOnTimeOperacional: 0,
      dataTotalTaksClosedOnLateOperacional: 0,
      dataTotalTaksOpenOnTimeOperacional: 0,
      dataTotalTaksOpenOnLateOperacional: 0,

      dataTaksClosedOnTimeOperacional: 0,
      dataTaskCloseOnLateOnWeekOperacional: 0,
      dataTaksOpenOnTimeOperacional: 0,
      dataTaskOpenOnLateOnWeekOperacional: 0,

      dataTotalTaksClosedOnTimeEstrategico: 0,
      dataTotalTaksClosedOnLateEstrategicoo: 0,
      dataTotalTaksOpenOnTimeEstrategico: 0,
      dataTotalTaksOpenOnLateEstrategico: 0,
      dataTaksClosedOnTimeEstrategico: 0,
      dataTaskCloseOnLateOnWeekEstrategico: 0,
      dataTaksOpenOnTimeEstrategico: 0,
      dataTaskOpenOnLateOnWeekEstrategico: 0,
      loadingForm: false
    };
  },
  // created() {
  //   console.log("ya se creo el componente ");
  //   filterDataEstrategico()
  //   console.log("Aqui termina la ejecucion del componetes")
  // },
  computed: {
    DateAutoMV() {
      let actualDate = formatDate(this.AutoMVFormModel.CreatedAt, "DD/MM/YYYY");
      return actualDate;
    }
  },
  mounted() {
    // console.log("Montado");
    // this.filterDataEstrategico()

    this.GetEmployeeBySupervisor();
    this.getEmployees();
  },
  methods: {
    filterDataEstrategico(tableDataEstrategico, tableDataOperacional) {
      this.loadingForm = true;
      this.tableDataEstrategico = tableDataEstrategico;
      this.tableDataOperacional = tableDataOperacional;

      if (this.departmentId != null) {
        this.tableDataEstrategico = tableDataEstrategico.filter(
          (x) => x.DeparmentID == this.departmentId
        );
        this.tableDataOperacional = tableDataOperacional.filter(
          (x) => x.DeparmentID == this.departmentId
        );
      }

      if (this.responsableId != "") {
        this.tableDataEstrategico = this.tableDataEstrategico.filter(
          (x) => x.ResponsableId == this.responsableId
        );

        this.tableDataOperacional = this.tableDataOperacional.filter(
          (x) => x.ResponsableId == this.responsableId
        );
      }

      const createdAt = new Date(this.createdAt);
      //Total de datareas cerrada a tiempo
      this.dataTotalTaksClosedOnTimeOperacional =
        this.tableDataOperacional.filter((data) => data.StausTasks == 1).length;

      //Total de datareas cerrada a tiempo en la semana

      this.dataTaksClosedOnTimeOperacional = this.tableDataOperacional.filter(
        (data) => {
          const fechaCierre = new Date(data.ClosedDate);

          var diferenciaMilisegundos = Math.abs(
            createdAt.getTime() - fechaCierre.getTime()
          );

          // Calcular la diferencia en días
          var diferenciaDias = Math.floor(
            diferenciaMilisegundos / (1000 * 60 * 60 * 24)
          );

          return (
            diferenciaDias <= 7 &&
            data.StausTasks == 1 &&
            data.TypeStrategic === 1
          );
        }
      ).length;

      // //Total de tareas cerrada retrasadas
      this.dataTotalTaksClosedOnLateOperacional =
        this.tableDataOperacional.filter((data) => data.StausTasks == 2).length;

      //Total de tareas cerrada retrasadas de la semana
      this.dataTaskCloseOnLateOnWeekOperacional =
        this.tableDataOperacional.filter((evento) => {
          // const fechaLimite = new Date(evento.LimiteDate);
          const fechaCierre = new Date(evento.ClosedDate);

          var diferenciaMilisegundos = Math.abs(
            createdAt.getTime() - fechaCierre.getTime()
          );

          // Calcular la diferencia en días
          var diferenciaDias = Math.floor(
            diferenciaMilisegundos / (1000 * 60 * 60 * 24)
          );

          return (
            diferenciaDias <= 7 &&
            evento.StausTasks == 2 &&
            evento.TypeStrategic === 1
          );
        }).length;

      this.dataTotalTaksOpenOnTimeOperacional =
        this.tableDataOperacional.filter((data) => data.StausTasks == 3).length;

      this.dataTaksOpenOnTimeOperacional = tableDataOperacional.filter(
        (evento) => {
          const fechaLimite = new Date(evento.LimiteDate);

          var diferenciaMilisegundos = Math.abs(
            createdAt.getTime() - fechaLimite.getTime()
          );

          // Calcular la diferencia en días
          var diferenciaDias = Math.floor(
            diferenciaMilisegundos / (1000 * 60 * 60 * 24)
          );

          return (
            diferenciaDias <= 7 &&
            fechaLimite >= createdAt &&
            evento.StausTasks == 3 &&
            evento.TypeStrategic === 1
          );
        }
      ).length;

      this.dataTotalTaksOpenOnLateOperacional =
        this.tableDataOperacional.filter((data) => data.StausTasks == 4).length;

      this.dataTaskOpenOnLateOnWeekOperacional =
        this.tableDataOperacional.filter((evento) => {
          const fechaLimite = new Date(evento.LimiteDate);

          var diferenciaMilisegundos = Math.abs(
            createdAt.getTime() - fechaLimite.getTime()
          );

          // Calcular la diferencia en días
          var diferenciaDias = Math.floor(
            diferenciaMilisegundos / (1000 * 60 * 60 * 24)
          );

          return (
            diferenciaDias <= 7 &&
            fechaLimite <= createdAt &&
            evento.StausTasks == 4 &&
            evento.TypeStrategic === 1
          );
        }).length;

      //LOGICA PARA OPERACIONAL
      this.datePercetangeWeekOperacional =
        (this.dataTaksClosedOnTimeOperacional /
          (this.dataTaksClosedOnTimeOperacional +
            this.dataTaskOpenOnLateOnWeekOperacional +
            this.dataTaskCloseOnLateOnWeekOperacional)) *
        100;

      this.datePercetangeWeekOperacional = Math.round(
        this.datePercetangeWeekOperacional
      );

      this.datePercetangeTotalOperacionall =
        (this.dataTotalTaksClosedOnTimeOperacional /
          (this.dataTotalTaksOpenOnLateOperacional +
            this.dataTotalTaksClosedOnTimeOperacional +
            this.dataTotalTaksClosedOnLateOperacional)) *
        100;
      this.datePercetangeTotalOperacionall = Math.round(
        this.datePercetangeTotalOperacionall
      );

      // Total de tareas completadas estrategico
      this.dataTotalTaksClosedOnTimeEstrategico =
        this.tableDataEstrategico.filter((data) => data.StausTasks == 1).length;

      this.dataTaksClosedOnTimeEstrategico = this.tableDataEstrategico.filter(
        (evento) => {
          const fechaCierre = new Date(evento.ClosedDate);

          var diferenciaMilisegundos = Math.abs(
            createdAt.getTime() - fechaCierre.getTime()
          );

          // Calcular la diferencia en días
          var diferenciaDias = Math.floor(
            diferenciaMilisegundos / (1000 * 60 * 60 * 24)
          );

          return diferenciaDias <= 7 && evento.StausTasks == 1;
        }
      ).length;

      // this.totalTaksClosedOnTimeEstrategico.push(d);
      this.dataTotalTaksClosedOnLateEstrategicoo =
        this.tableDataEstrategico.filter((data) => data.StausTasks == 2).length;

      this.dataTaskCloseOnLateOnWeekEstrategico =
        this.tableDataEstrategico.filter((evento) => {
          const fechaCierre = new Date(evento.ClosedDate);

          var diferenciaMilisegundos = Math.abs(
            createdAt.getTime() - fechaCierre.getTime()
          );

          // Calcular la diferencia en días
          var diferenciaDias = Math.floor(
            diferenciaMilisegundos / (1000 * 60 * 60 * 24)
          );

          return diferenciaDias <= 7 && evento.StausTasks == 2;
        }).length;

      this.dataTotalTaksOpenOnTimeEstrategico =
        this.tableDataEstrategico.filter((data) => data.StausTasks == 3).length;

      this.dataTaksOpenOnTimeEstrategico = this.tableDataEstrategico.filter(
        (evento) => {
          const fechaLimite = new Date(evento.LimiteDate);

          var diferenciaMilisegundos = Math.abs(
            createdAt.getTime() - fechaLimite.getTime()
          );

          // Calcular la diferencia en días
          var diferenciaDias = Math.floor(
            diferenciaMilisegundos / (1000 * 60 * 60 * 24)
          );

          return (
            diferenciaDias <= 7 &&
            fechaLimite >= createdAt &&
            evento.StausTasks == 4 &&
            evento.TypeStrategic === 2
          );
        }
      ).length;
      this.dataTotalTaksOpenOnLateEstrategico =
        this.tableDataEstrategico.filter((data) => data.StausTasks == 4).length;

      this.dataTaskOpenOnLateOnWeekEstrategico =
        this.tableDataEstrategico.filter((evento) => {
          const fechaLimite = new Date(evento.LimiteDate);

          var diferenciaMilisegundos = Math.abs(
            createdAt.getTime() - fechaLimite.getTime()
          );

          // Calcular la diferencia en días
          var diferenciaDias = Math.floor(
            diferenciaMilisegundos / (1000 * 60 * 60 * 24)
          );

          return (
            diferenciaDias <= 7 &&
            fechaLimite <= createdAt &&
            evento.StausTasks == 4 &&
            evento.TypeStrategic === 2
          );
        }).length;

      //LOGICA PAR ESTRATEGICO
      this.datePercetangeWeekEstrategico =
        (this.dataTaksClosedOnTimeEstrategico /
          (this.dataTaksClosedOnTimeEstrategico +
            this.dataTaskCloseOnLateOnWeekEstrategico +
            this.dataTaskOpenOnLateOnWeekEstrategico)) *
        100;

      this.datePercetangeWeekEstrategico = Math.round(
        this.datePercetangeWeekEstrategico
      );

      this.datePercetangeTotalEstrategico =
        (this.dataTotalTaksClosedOnTimeEstrategico /
          (this.dataTotalTaksOpenOnLateEstrategico +
            this.dataTotalTaksClosedOnTimeEstrategico +
            this.dataTotalTaksClosedOnLateEstrategicoo)) *
        100;

      this.datePercetangeTotalEstrategico = Math.round(
        this.datePercetangeTotalEstrategico
      );

      // const dataEstrategica = this.LogicaPorcentaje(this.tableDataEstrategico);
      // const dataOperacional = this.LogicaPorcentaje(this.tableDataOperacional);

      // this.porcentajeDelCalculo(dataEstrategica, dataOperacional);
      // this.porcentajeDelCalculo(1, dataOperacional);
      this.loadingForm = false;
    },
    // LogicaPorcentaje(tableData, type) {
    // console.log("Llegue");
    // let today = new Date();
    // let validateToday = today.getDay();
    // // Obtener la fecha de inicio y fin de la semana actual
    // const fechaActual = new Date();
    // const primerDiaSemanaActual = new Date(
    //   fechaActual.setDate(fechaActual.getDate() - fechaActual.getDay())
    // );
    // const ultimoDiaSemanaActual = new Date(
    //   fechaActual.setDate(primerDiaSemanaActual.getDate() + 6)
    // );

    // const ultimoDiaSemanaPasada = new Date(
    //   fechaActual.setDate(primerDiaSemanaActual.getDate() - 1)
    // );

    // const primerDiaSemanaPasada = new Date(
    //   fechaActual.setDate(ultimoDiaSemanaPasada.getDate() - 6)
    // );

    // let totalTaksClosedOnTime = [];
    // let totalTaksClosedOnLate = [];
    // let taskCloseOnLateOnWeek = [];
    // let totalTaksOpenOnTime = [];
    // let totalTaksOpenOnLate = [];
    // let taskOpenOnLateOnWeek = [];

    // tableData.forEach((d) => {
    //   if (d.StausTasks == 1) {
    //     totalTaksClosedOnTime.push(d);
    //   } else if (d.StausTasks == 2) {
    //     totalTaksClosedOnLate.push(d);

    //     taskCloseOnLateOnWeek = tableData.filter((evento) => {
    //       const fechaCierre = new Date(evento.LimiteDate);

    //       if (
    //         validateToday == 5 /*viernes*/ ||
    //         validateToday == 6 /*Sabado*/
    //       ) {
    //         return (
    //           fechaCierre >= primerDiaSemanaActual &&
    //           fechaCierre <= ultimoDiaSemanaActual &&
    //           evento.StausTasks == 2
    //         );
    //       }
    //       return (
    //         fechaCierre >= primerDiaSemanaPasada &&
    //         fechaCierre <= ultimoDiaSemanaPasada &&
    //         evento.StausTasks == 2
    //       );
    //     });
    //   } else if (d.StausTasks == 3) {
    //     totalTaksOpenOnTime.push(d);
    //   } else if (d.StausTasks == 4) {
    //     totalTaksOpenOnLate.push(d);

    //     taskOpenOnLateOnWeek = tableData.filter((evento) => {
    //       // console.log("aaaa",primerDiaSemana, ultimoDiaSemana)
    //       // console.log("pasada",primerDiaSemanaPasada, ultimoDiaSemanaPasada)
    //       const fechaCierre = new Date(evento.LimiteDate);

    //       if (
    //         validateToday == 5 /*viernes*/ ||
    //         validateToday == 6 /*Sabado*/
    //       ) {
    //         return (
    //           fechaCierre >= primerDiaSemanaActual &&
    //           fechaCierre <= ultimoDiaSemanaActual &&
    //           evento.StausTasks == 4
    //         );
    //       }
    //       return (
    //         fechaCierre >= primerDiaSemanaPasada &&
    //         fechaCierre <= ultimoDiaSemanaPasada &&
    //         evento.StausTasks == 4
    //       );
    //     });
    //   }
    // });

    // // let porcentaje =
    // //   this.tableDataEstrategico.filter((x) => x.StausTasks === 1).length /
    // //   this.tableDataEstrategico;

    // // totalTaksClosedOnTime.length,
    // // const valueTotalTaksClosedOnTime = totalTaksClosedOnTime.length
    // // const valueTotalTaksClosedOnLate = totalTaksClosedOnLate.length
    // // const valueTaskCloseOnLateOnWeek = taskCloseOnLateOnWeek.length
    // // const valueTotalTaksOpenOnTime = totalTaksOpenOnTime.length
    // // const valueTotalTaksOpenOnLate = totalTaksOpenOnLate.length
    // // const valueTaskOpenOnLateOnWeek =
    // return {
    //   totalTaksClosedOnTime,
    //   totalTaksClosedOnLate,
    //   taskCloseOnLateOnWeek,
    //   totalTaksOpenOnTime,
    //   totalTaksOpenOnLate,
    //   taskOpenOnLateOnWeek
    // };
    // },
    // filterDataOperacional() {
    //   this.loadingFormItem = true;

    //   this.tableDataOperacional = this.TasktableDataOperacional;

    //   if(this.departmentId != null)
    //     this.tableDataOperacional = this.tableDataOperacional.filter(x => x.DeparmentID == this.departmentId)

    //   this.loadingFormItem = false;

    // },
    employeeChage() {
      this.filterDataEstrategico(
        this.TasktableDataEstrategico,
        this.TasktableDataOperacional
      );
    },
    selectionChange(DepartmentID) {
      this.departmentId = DepartmentID;
      this.filterDataEstrategico(
        this.TasktableDataEstrategico,
        this.TasktableDataOperacional
      );
    },
    porcentajeDelCalculo(data1, data2) {
      //LOGICA PAR ESTRATEGICA
      let percetangeWeekEs =
        (data1.totalTaksClosedOnTime.length /
          (data1.totalTaksClosedOnTime.length +
            data1.taskOpenOnLateOnWeek.length +
            data1.taskCloseOnLateOnWeek.length)) *
        100;

      percetangeWeekEs = Math.round(percetangeWeekEs);

      this.datePercetangeWeekOperacional =
        this.totalPorcentaje(percetangeWeekEs);

      let percetangeTotalEs =
        (data1.totalTaksClosedOnTime
          .length /*+ this.totalTaksClosedOnLate*/ /*this.totalTaksOpenOnTime +*/ /
          (data1.totalTaksOpenOnLate.length +
            data1.totalTaksClosedOnTime.length +
            data1.totalTaksClosedOnLate.length)) *
        100;

      percetangeTotalEs = Math.round(percetangeTotalEs);

      this.datePercetangeTotalOperacional =
        this.totalPorcentaje(percetangeTotalEs);

      //LOGICA PAR OPERACIONAL
      let percetangeWeekOp =
        (data2.totalTaksClosedOnTime.length /
          (data2.totalTaksClosedOnTime.length +
            data2.taskOpenOnLateOnWeek.length +
            data2.taskCloseOnLateOnWeek.length)) *
        100;

      percetangeWeekOp = Math.round(this.percetangeWeekOp);

      this.datePercetangeWeekEstrategico =
        this.totalPorcentaje(percetangeWeekOp);

      let percetangeTotalOp =
        (data2.totalTaksClosedOnTime
          .length /*+ this.totalTaksClosedOnLate*/ /*this.totalTaksOpenOnTime +*/ /
          (data2.totalTaksOpenOnLate.length +
            data2.totalTaksClosedOnTime.length +
            data2.totalTaksClosedOnLate.length)) *
        100;

      percetangeTotalOp = Math.round(percetangeTotalOp);

      this.datePercetangeTotalEstrategico =
        this.totalPorcentaje(percetangeTotalOp);
    },
    totalPorcentaje(value) {
      return isNaN(value) ? 0 : value;
    },
    handleClick(tab) {
      this.indexTabs = tab.index;
    },
    onClose() {
      this.$emit("onClose", this.openAutoMVView);
    },
    async onSubmit() {
      this.loading = true;
      if (this.Ranting.length != 0 && this.RantingComment.length > 0) {
        let params = {
          Id: this.AutoMVFormModel.Id,
          Ranting: this.Ranting,
          RatingComment: this.RantingComment
        };

        await this.$http
          .post("/api/CMI/AutoMVs/QualifyAutoMVs", params)
          .then((/*response*/) => {
            this.$emit("onClose");
            return;
          })
          .catch((err) => {
            this.$message({
              type: "error",
              message: err
            });
          })
          .finally(() => {
            this.Ranting = "";
            this.RantingComment = "";
            this.$emit("refresh-table");
            this.$emit("onClose");
            this.loading = false;
          });
        return;
      }
      this.loading = false;
      this.$message({
        type: "error",
        message:
          "Debese de ingresar la calificación y el comentario de la calificación"
      });
    },
    getEmployees() {
      let uri = "";
      const company = this.currentCompany;
      const employeeId = this.currentUser.EmployeeId;

      if (this.directionId > 0) {
        uri = `/api/Employees/GetEmployeeByCriteria?DepartmentID=${this.deparmentId}&DirectionID=${this.directionId}`;
      } else {
        uri = `/api/CMI/Objetives/GetUsersObjetivos?CompanySelected=${company}&employeeid=${employeeId}`;
      }

      this.$http
        .get(uri)
        .then((response) => {
          this.employees = response.data;
        })
        .catch(() => {});
    },
    GetEmployeeBySupervisor() {
      let uri = `/api/Employees/GetEmployeeByCriteriaSupervisor?employeeid=${this.currentUser.EmployeeId}`;
      this.$http
        .get(uri)
        .then((resp) => {
          if (this.currentUser.EmployeeId != 37) {
            resp.data.user.forEach((element) => {
              this.employeesByDirection.push({
                EmployeeID: element.EmployeeID
                  ? element.EmployeeID
                  : element.Id,
                Name: element.FullName ? element.FullName : element.Name
              });
            });

            resp.data.okEmployee.forEach((element) => {
              this.employeesByDirection.push({
                EmployeeID: element.EmployeeID
                  ? element.EmployeeID
                  : element.Id,
                Name: element.FullName ? element.FullName : element.Name
              });
            });
          }
        })
        .catch((err) => {
          if (err.message.includes("404")) {
            const h = this.$createElement;
            this.$message({
              type: "info",
              //message: "Cliente no encontrado, consultelo en otra empresa"
              message: h("p", null, [
                h("span", null, "Empleado no "),
                h("i", { style: "color: teal" }, "encontrado")
              ])
            });
          } else {
            this.$alert(err.message, err.name, {
              type: "error"
            });
          }
        });
    }
  },
  watch: {
    loadingFormItem() {
      this.loadingForm = this.loadingFormItem;
    },
    TasktableDataEstrategico() {
      this.tableDataEstrategico = this.TasktableDataEstrategico;
      this.tableDataOperacional = this.TasktableDataOperacional;

      this.datePercetangeWeekOperacional = this.percetangeWeekOperacional;
      this.datePercetangeTotalOperacionall = this.percetangeTotalOperacionall;

      this.dataTotalTaksClosedOnTimeOperacional =
        this.totalTaksClosedOnTimeOperacional;
      this.dataTotalTaksClosedOnLateOperacional =
        this.totalTaksClosedOnLateOperacional;
      this.dataTotalTaksOpenOnTimeOperacional =
        this.totalTaksOpenOnTimeOperacional;
      this.dataTotalTaksOpenOnLateOperacional =
        this.totalTaksOpenOnLateOperacional;

      this.dataTaksClosedOnTimeOperacional = this.taksClosedOnTimeOperacional;
      this.dataTaskCloseOnLateOnWeekOperacional =
        this.taskCloseOnLateOnWeekOperacional;
      this.dataTaksOpenOnTimeOperacional = this.taksOpenOnTimeOperacional;
      this.dataTaskOpenOnLateOnWeekOperacional =
        this.taskOpenOnLateOnWeekOperacional;

      this.datePercetangeWeekEstrategico = this.percetangeWeekEstrategico;
      this.datePercetangeTotalEstrategico = this.percetangeTotalEstrategico;

      this.dataTotalTaksClosedOnTimeEstrategico =
        this.totalTaksClosedOnTimeEstrategico;
      this.dataTotalTaksClosedOnLateEstrategicoo =
        this.totalTaksClosedOnLateEstrategicoo;
      this.dataTotalTaksOpenOnTimeEstrategico =
        this.totalTaksOpenOnTimeEstrategico;
      this.dataTotalTaksOpenOnLateEstrategico =
        this.totalTaksOpenOnLateEstrategico;

      this.dataTaksClosedOnTimeEstrategico = this.taksClosedOnTimeEstrategico;
      this.dataTaskCloseOnLateOnWeekEstrategico =
        this.taskCloseOnLateOnWeekEstrategico;
      this.dataTaskOpenOnLateOnWeekEstrategico =
        this.taskOpenOnLateOnWeekEstrategico;
      this.dataTaksOpenOnTimeEstrategico = this.taksOpenOnTimeEstrategico;
    }
  }
};
</script>

<style>
.dialog-automv .el-dialog__header {
  background-color: white !important;
  border-bottom: 0px solid #72767b !important;
}

.dialog-automv .el-dialog__close {
  font-size: 20px !important;
}
.dialog-automv .el-dialog__close:hover {
  transform: scale(1.5) !important;
}
.rowTags {
  /*padding: 10px;*/
}
.rowDate {
  margin-bottom: 0;
}
.quilBottom {
  margin-bottom: 11%;
}

.overlap-group {
  align-items: center;
  background-color: rgba(35, 132, 199, 1);
  display: flex;
  height: 42px;
  min-width: 222px;
  padding: 0 47px;
}
.objetivos-AutoMV {
  letter-spacing: 0;
  line-height: normal;
  min-height: 24px;
  min-width: 115px;
}
.overlap-group6-AutoMV {
  height: 225px;
  position: absolute;
  top: 100px;
  right: 72px;
  width: 671px;
}
.rectangle-3-AutoMV {
  background-color: rgba(35, 132, 199, 1);
  height: 147px;
  left: 72px;
  position: absolute;
  top: 0;
  width: 597px;
}
.title-AutoMV {
  color: white;
  font-family: inherit;
  font-size: 40px;
  font-weight: 700;
  left: 364px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 19px;
}
.ActualDate-AutoMV {
  color: white;
  font-family: inherit;
  font-size: 17px;
  font-weight: 700;
  left: 370px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 80px;
}
.rectangle-4-AutoMV {
  background-color: white;
  height: 211px;
  left: 55px;
  bottom: 10px;
  position: absolute;
  transform: rotate(-44.08deg);
  width: 102px;
}
.overlap-group-1-AutoMV {
  align-items: center;
  background-color: rgba(35, 132, 199, 1);
  display: flex;
  height: 42px;
  min-width: 222px;
  padding: 0 27px;
}
.label-description-AutoMV {
  letter-spacing: 8;
  line-height: normal;
  margin-bottom: 4px;
  min-height: 24px;
  min-width: 494px;
  color: black;
  font-weight: bold;
  font-size: 17px;
}

.labels-AutoMV {
  align-items: flex-end;
  align-self: flex-start;
  display: flex;
  gap: 5px;
  margin-left: 23px;
  margin-bottom: 28px;
  min-width: 640px;
}
.texts-labels-AutoMV {
  color: white;
  letter-spacing: 8;
  text-align: center;
  line-height: normal;
  font-weight: bold;
  min-height: 24px;
  min-width: 168px;
}
</style>
